
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/creator",
      function () {
        return require("private-next-pages/creator/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/creator"])
      });
    }
  